import { useRef, useState, useEffect } from "react";
import EmrConfigService from "../../services/EmrConfigService";
import { isSet } from "../../utils/commonUtils";
import Buttons from "../../components/UI/Buttons";
import PERMISSIONS from "../../utils/AclPermissions";
import WithRouter from "../../hoc/WithRouter";
import { OK } from "../../utils/constant";
import ProgressNote from "./ProgressNote";
import EmrPageTab from "./Tabs/EmrPages/EmrPageTab";
import NotesAlerts from "./Tabs/ChartNotesTabs/NotesAlerts";
import ImagesTab from "./Tabs/ChartNotesTabs/ImagesTab";
import ConfidentialNotes from "./Tabs/ChartNotesTabs/ConfidentialNotes";
import AssesmentTab from "./Tabs/AssesmentTab/AssesmentTab";
import ChartNote from "./Tabs/ChartNotesTabs/ChartNote";
import FormsTab from "./Tabs/ChartNotesTabs/FormsTab";
import WorkRestrictionsTab from "./Tabs/WorkRestrictionsTab";
const RightContent = ({
  visit_id,
  employeeId,
  Toast,
  Loader,
  visitDetails,
  params,
  ...props
}) => {
const [Headers, setHeaders] = useState({});

useEffect(() => {
  const visitCategory = visitDetails["0"]?.visit_category;
  if (!visitCategory) return;

  const newHeaders = visitCategory === "Work Comp - Physical Therapy"
    ? {
        Subjective: [
        { label: "Complaint", apikey: "SUBJECTIVE_COMPLAINT", component: EmrPageTab },
        { label: "HPI", apikey: "SUBJECTIVE_HPI", component: EmrPageTab },
        { label: "PMH", apikey: "SUBJECTIVE_PMH", component: EmrPageTab },
        { label: "ROS", apikey: "SUBJECTIVE_ROS", component: EmrPageTab },
        ],
        Objective: [
          { label: "ROM / Tests", apikey: "SOAP_ROM_TESTS", component: EmrPageTab },
          { label: "Exercise", apikey: "SOAP_EXERCISE", component: EmrPageTab },
          { label: "Reeducation", apikey: "SOAP_REEDUCATION", component: EmrPageTab },
          { label: "Activities", apikey: "SOAP_ACTIVITIES", component: EmrPageTab },
          { label: "Modalities", apikey: "SOAP_MODALITIES", component: EmrPageTab },
        ],
        Assessment: [{ label: "Assessment", apikey: "SOAP_ASSESSMENT", component: EmrPageTab }],
        Plan: [{ label: "Plan", apikey: "SOAP_PLAN", component: EmrPageTab }],
        "Chart by Superbill": [
          { label: "Work Restrictions", apikey: "WORK_RESTRICTIONS", component: EmrPageTab },
          { label: "School Note", apikey: "SCHOOL_NOTE", component: EmrPageTab },
          { label: "Return/FollowUp", apikey: "RETURN_FOLLOWUP", component: EmrPageTab },
          { label: "Forms", apikey: "FORMS", component: EmrPageTab },
          { label: "Referrals", apikey: "REFFERALS", component: EmrPageTab },
        ],
        "Chart Note": [
          { label: "Forms", apikey: "FORMS", component: FormsTab },
          { label: "Images", apikey: "IMAGES", component: ImagesTab },
          { label: "Chart Notes", apikey: "CHART_NOTES", component: ChartNote },
          { label: "Notes & Alerts", apikey: "ALERT_NOTES", component: NotesAlerts },
          { label: "Confidential Notes", apikey: "CONFIDENTIAL_NOTES", component: ConfidentialNotes },
        ],
        "Super Dictation": [
          { label: "Chart by Superbill", apikey: "PHYSICAL_THERAPY_BY_SUPERBILL", component: EmrPageTab },
          { label: "Chart by Dictation", apikey: "PHYSICAL_THERAPY_BY_DICTATION", component: EmrPageTab },
        ],
      }
    : {
      Complaint: [{ label: "Complaint", apikey: "COMPLAINT", component: EmrPageTab }],
        History: [
          { label: "HPI", apikey: "HPI", component: EmrPageTab },
          { label: "PMH", apikey: "PMH", component: EmrPageTab },
          { label: "ROS", apikey: "ROS", component: EmrPageTab },
        ],
        Examination: [
          { label: "Musculoskeletal", apikey: "MUSCULOSKELETAL", component: EmrPageTab },
          { label: "Organ Systems", apikey: "ORGAN_SYSTEMS", component: EmrPageTab },
          { label: "Problem Focused", apikey: "PROBLEM_FOCUSED", component: EmrPageTab },
          { label: "ROM / Testing", apikey: "ROM_TESTING", component: EmrPageTab },
          { label: "Lacerations", apikey: "EXAMINATION_LACERATIONS", component: EmrPageTab },
        ],
        "Order/Results": [
          { label: "X-ray", apikey: "X_RAY", component: EmrPageTab },
          // { label: "Lab / Diagnostic", apikey: "LAB_DIAGNOSTIC", component: EmrPageTab },
          { label: "Labs", apikey: "LAB", component: EmrPageTab },
          { label: "Diagnostics", apikey: "DIAGNOSTIC", component: EmrPageTab },
          { label: "Treatments", apikey: "TREATMENTS", component: EmrPageTab },
          { label: "Inject / Vaccines", apikey: "INJECT_VACCINES", component: EmrPageTab },
          { label: "Prescriptions", apikey: "PRESCRIPTIONS", component: EmrPageTab },
          { label: "DMEs", apikey: "DMES", component: EmrPageTab },
          { label: "Referrals", apikey: "REFERRALS", component: EmrPageTab },
        ],
        Assessment: [{ label: "Assessment", apikey: "ASSESSMENT", component: AssesmentTab }],
        Procedures: [
          { label: "Lacerations", apikey: "PROCEDURES_LACERATIONS", component: EmrPageTab },
          { label: "Other Procedures", apikey: "OTHER_PROCEDURES", component: EmrPageTab },
        ],
        "Discharge": [
          { label: "Work Restrictions", apikey: "WORK_RESTRICTIONS", component: WorkRestrictionsTab },
          { label: "School Note", apikey: "SCHOOL_NOTE", component: EmrPageTab },
          { label: "Return/FollowUp", apikey: "RETURN_FOLLOWUP", component: EmrPageTab },
          { label: "Forms", apikey: "FORMS", component: FormsTab },
          { label: "Referrals", apikey: "REFFERALS", component: EmrPageTab },
        ],
        "Chart Note": [
          { label: "Forms", apikey: "FORMS", component: FormsTab },
          { label: "Images", apikey: "IMAGES", component: ImagesTab },
          { label: "Chart Notes", apikey: "CHART_NOTES", component: ChartNote },
          { label: "Notes & Alerts", apikey: "ALERT_NOTES", component: NotesAlerts },
          { label: "Confidential Notes", apikey: "CONFIDENTIAL_NOTES", component: ConfidentialNotes },
        ],
        "Super Dictation": [
          { label: "Chart by Superbill", apikey: "CHART_BY_SUPERBILL", component: EmrPageTab },
          { label: "Chart by Dicatation", apikey: "CHART_BY_DICTATION", component: EmrPageTab },
        ],
      };

  setHeaders(newHeaders);
  const defaultTab = visitCategory === "Work Comp - Physical Therapy" ? "Subjective" : "Order/Results";
  setSelectedTab(defaultTab);
  setSelectedSubTab(newHeaders[defaultTab]?.[0]?.apikey || "");
}, [visitDetails]);

  const [selectedTab, setSelectedTab] = useState("Order/Results");
  const [selectedSubTab, setSelectedSubTab] = useState(
    Headers[selectedTab]?.[0]?.apikey || ""
  );
  const [expandedSection, setExpandedSection] = useState(null);
  const [inactiveLeft, setInactiveLeft] = useState(true);
  const [progressNote, setProgressNote] = useState("");
  const scrollerRef = useRef(null);

  useEffect(() => {
    const checkScroller = () => {
      setInactiveLeft(scrollerRef.current.scrollLeft === 0);
    };

    const handleScroll = () => {
      setInactiveLeft(scrollerRef.current.scrollLeft === 0);
    };

    checkScroller();
    if (scrollerRef.current) {
      scrollerRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollerRef.current) {
        scrollerRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const fetchProgressNotesByScreen = async () => {
    Loader(true);
    try {
      const response = await EmrConfigService.visifetchProgressData(
        visit_id,
        selectedSubTab
      );
      Loader(false);
      if (response.code !== OK) {
        console.error("API response not successful:", response);
        return false;
      }
      const data = response.data || {};
      const display_value = data.display_value ?? null;
      setProgressNote(isSet(display_value, ""));
    } catch (err) {
      console.error("Error fetching progress data:", err);
      Loader(false);
    }
  };

  const updateProgress = async (visit_id, data) => {
    try {
      const payload = {
        displayText: data,
      };
      const response = await EmrConfigService.upateProcessData(
        visit_id,
        selectedSubTab,
        payload
      );

      if (data === " ") {
        Toast.success(" Data Cleared");
      } else {
        Toast.success("Data Updated ");
      }
      await fetchProgressNotesByScreen();
    } catch (error) {
      console.error("Failed to update progress data :", error);
    }
  };

  const handleRightClick = () => {
    scrollerRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };

  const handleLeftClick = () => {
    scrollerRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const handleTabClick = (label, index) => {
    setSelectedTab(label);
    if(label === "Chart Note") {
      setSelectedSubTab("CHART_NOTES");
    } else {
    setSelectedSubTab(Headers[label]?.[0]?.apikey || "");
    }
    setExpandedSection(null);
  };

  const handleSubTabClick = (apikey) => {
    setSelectedSubTab(apikey);
    setExpandedSection(null);
  };
  const tabHeaders = Headers[selectedTab] || [];
  const SelectedComponent = tabHeaders.find(
    (header) => header?.apikey === selectedSubTab
  );

  return (
    <div className="col-lg-9 col-12">
      <div className="sh_cardBox h-auto sh_visit">
        {/* <div className="sh_cardHeader" style={{ zIndex: 1 }}>
          <div className="form-group d-flex mb-0 justify-content-center align-items-center">
            <StatusBar visitDetails={visitDetails} />
          </div>
        </div> */}

        {/* tabs */}
        <div
          className="sh_cardBody py-0 statusBadge"
          style={{ position: "relative" }}
        >
          <div style={{ overflowX: "hidden" }}>
            <div
              className="react-swipeable-view-container"
              style={{
                flexDirection: "row",
                transition: "all",
                direction: "ltr",
                display: "flex",
                willChange: "transform",
                transform: "translate(0%, 0px)",
              }}
            >
              <div
                aria-hidden="false"
                data-swipeable="true"
                style={{
                  width: "100%",
                  flexShrink: 0,
                  overflow: "auto",
                }}
              >
                <div
                  role="tabpanel"
                  // title="Physical"
                  id="full-width-tabpanel-0"
                  aria-labelledby="full-width-tab-0"
                >
                  <div className="sh_innerPortview">
                    <div className="sh_cardBox shadow-none border-0 mb-0" style={{height: "calc(100vh - 95px)"}}>
                      <TabNavigation
                        handleLeftClick={handleLeftClick}
                        handleRightClick={handleRightClick}
                        tabHeaders={Object.keys(Headers).map((key) => ({
                          label: key,
                        }))}
                        selectedTab={selectedTab}
                        handleTabClick={handleTabClick}
                        scrollerRef={scrollerRef}
                        inactiveLeft={inactiveLeft}
                        params={params}
                      />

                      <SubTabNavigation
                        subTabs={Headers[selectedTab] || []}
                        selectedSubTab={selectedSubTab}
                        onSubTabClick={handleSubTabClick}
                      />
                      {SelectedComponent?.component ? (
                        <SelectedComponent.component
                          selectedSubTab={selectedSubTab}
                          visit_id={visit_id}
                          setExpandedSection={setExpandedSection}
                          fetchProgressNotesByScreen={
                            fetchProgressNotesByScreen
                          }
                          Loader={Loader}
                          Toast={Toast}
                          employeeId={employeeId}
                          expandedSection={expandedSection}
                          selectedTab={selectedTab}
                          setSelectedSubTab={setSelectedSubTab}
                          selectedBodyPart={
                            props.selectedBodyPart
                          }
                          setSelecetedBodyParts={
                            props.setSelecetedBodyParts
                          }
                          isrenderICD={
                            props.isrenderICD
                          }
                        />
                      ) : null}

                      {/* progress note */}
                      {!["Chart Note"].includes(
                        selectedTab
                      ) && (
                        <ProgressNote
                          updateProgress={updateProgress}
                          progressNote={progressNote}
                          visit_id={visit_id}
                          setProgressNote={setProgressNote}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const TabNavigation = ({
  handleLeftClick,
  handleRightClick,
  tabHeaders,
  selectedTab,
  handleTabClick,
  scrollerRef,
  inactiveLeft,
  params,
}) => (
  <div className="sh_cardHeader" style={{ position: "relative" }}>
    <div className="form-group d-flex mb-0 justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <h6 class="text-lg f-500 mb-0">
          <Buttons
            className="badge back_btn ml-3 "
            label={"Back"}
            iconType={"Back"}
            acl={PERMISSIONS.VISITS.LIST}
            href={
              isSet(params.backTo, null) != null
                ? `/${params.backTo}`
                : "/visits"
            }
            //  hrefState={props?.location?.state}
          />
        </h6>
      </div>
      <div className="tabs-wrapper">
        <span
          // className={`left scroller-btn ${inactiveLeft ? "inactive" : ""}`}
          className={`left scroller-btn active" : ""}`}
          onClick={handleLeftClick}
        >
          <i className="fa fa-chevron-left" aria-hidden="true"></i>
        </span>
        <ul className="nav nav-borders nav-tabs border-0" ref={scrollerRef}>
          {tabHeaders.map((header, index) => (
            <li key={index}>
              <a
                className={`nav-link ${
                  selectedTab === header.label ? "active" : ""
                }`}
                onClick={() => handleTabClick(header.label, index)}
              >
                {header.label}
              </a>
            </li>
          ))}
        </ul>
        <span className="right scroller-btn active" onClick={handleRightClick}>
          <i className="fa fa-chevron-right" aria-hidden="true"></i>
        </span>
      </div>
    </div>
  </div>
);

const SubTabNavigation = ({ subTabs, selectedSubTab, onSubTabClick }) => {
  return (
    <div className="sh_cardHeader" style={{ position: "relative", padding: 0 }}>
      <div className="form-group mb-0 d-flex justify-content-center align-items-center">
        <div className="tabs-wrapper">
          <ul className="nav nav-borders nav-tabs sh_emrnavtab border-0">
            {subTabs.map(({ apikey, label }, index) => (
              <li key={index}>
                <a
                  className={`nav-link ${
                    selectedSubTab === apikey ? "active" : ""
                  }`}
                  onClick={() => onSubTabClick(apikey)}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WithRouter(RightContent);
